<template>
    <div class="calendar">
        <el-button type="primary" class="add-calendar-btn fr" @click="addNewCalendar">新建日程</el-button>

        <div :class="month_view==true?'nav month-nav clear':'nav week-nav clear'">
            <div v-if="month_view" class="select-date fl">
                <el-select class="select-year" v-model="yearValue" placeholder="年" @change="changeCurrentTime">
                    <el-option v-for="item in yearOptions" :key="item.yearValue" :label="item.label" :value="item.yearValue">
                    </el-option>
                </el-select>
                <el-select class="select-month" v-model="monthValue" placeholder="月" @change="changeCurrentTime">
                    <el-option v-for="item in monthOptions" :key="item.monthValue" :label="item.label" :value="item.monthValue">
                    </el-option>
                </el-select>
            </div>
            <div v-if="!month_view" class="select-date fl">
                <el-select class="select-team" v-model="term_id" placeholder="选择学期" @change="getTerm()">
                    <el-option v-for="item in teamOptions" :key="item.id" :label="item.start_year+ '-' +item.end_year+item.semester_name" :value="item.id">
                    </el-option>
                </el-select>
                <el-select class="select-week" v-model="weekValue" placeholder="选择周" @change="getTermWeek">
                    <el-option v-for="item in weekOptions" :key="item" :label="'第'+item+'周'" :value="item">
                    </el-option>
                </el-select>
            </div>
            <full-calendar :events="events" ref="calendar" :config="config" @event-selected="eventSelected" @view-render="getView"></full-calendar>
            <div class="table-tips clear">
                <span>
                    <i class="c-color4"></i>
                    <i>个人日程</i>
                </span>
                <span>
                    <i class="c-color3"></i>
                    <i>班级日程</i>
                </span>
                <span>
                    <i class="c-color2"></i>
                    <i>年级日程</i>
                </span>
                <span>
                    <i class="c-color1"></i>
                    <i>学校日程</i>
                </span>
            </div>
        </div>

        <el-dialog :title="statusType==0?'新建日程':'编辑'" :visible.sync="dialogVisible" width="30%" @closed="closeDialog">
            <el-form :model="calendarForm" :rules="rules" ref="calendarForm" label-width="85px">
                <el-form-item label="日程内容" prop="content">
                    <el-input v-model="calendarForm.content" placeholder="30个字符以内" maxlength="30"></el-input>
                </el-form-item>
                <el-form-item label="日程类型" prop="type">
                    <el-select v-model="calendarForm.type" placeholder="请选择日程">
                        <template v-for="(item,index) in calendar_options">
                            <el-option :key="index" :label="item.label" :value="item.value"></el-option>
                        </template>
                    </el-select>
                </el-form-item>

                <el-form-item v-if="calendarForm.type==2" label="参与班级" prop="class_id">
                    <el-checkbox-group v-model="calendarForm.class_id">
                        <el-checkbox v-for="(item,index) in class_options" :label="item.id" :key="index">{{item.rename}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-form-item v-if="calendarForm.type==3" label="参与年级" prop="grade_id">
                    <el-cascader v-model="calendarForm.grade_id" :options="orgData" :props="orgDataProps" placeholder="请选择年级" :show-all-levels="false"></el-cascader>
                </el-form-item>

                <el-form-item v-if="calendarForm.type!=1&&calendarForm.type!=''" label="参与人员" prop="role_id">
                    <template>
                        <el-checkbox-group v-model="calendarForm.role_id">
                            <el-checkbox label="6">教师</el-checkbox>
                            <el-checkbox label="4">学生</el-checkbox>
                            <el-checkbox label="5">家长</el-checkbox>
                        </el-checkbox-group>
                    </template>
                </el-form-item>

                <el-form-item label="开始时间" prop="start_time">
                    <el-date-picker v-model="calendarForm.start_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="结束时间" prop="end_time">
                    <el-date-picker v-model="calendarForm.end_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="重要活动" prop="is_import">
                    <el-radio-group v-model="calendarForm.is_import">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="0">否</el-radio>
                    </el-radio-group>
                    <span class="is_import_tips">(重要活动有星号标记)</span>
                </el-form-item>

                <el-form-item label="重复" prop="repeat">
                    <el-select v-model="calendarForm.repeat" placeholder="请选择周期">
                        <el-option v-for="item in repeat_options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="备注" class="textarea-item" prop="remark">
                    <el-input type="textarea" :rows="4" resize="none" v-model.trim="calendarForm.remark" maxlength="140"></el-input>
                    <span class="word-sum">
                        <i>{{calendarForm.remark.length}}</i>/140</span>
                </el-form-item>

                <el-form-item v-if="statusType==1&&user_id!=c_create_id" label="创建人：" prop="">
                    <span>{{c_creater_name}}</span>
                </el-form-item>

                <el-form-item v-if="statusType==1" label="创建日期：" prop="">
                    <span>{{c_create_time}}</span>
                </el-form-item>

                <el-form-item v-if="statusType==0||user_id==c_create_id">
                    <el-button v-if="statusType==1" type="danger" size="small" @click="delCalendar">删 除</el-button>
                    <el-button size="small" @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" size="small" v-loading.fullscreen="submitLoading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-text="正在提交..." @click="submitForm('calendarForm')">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="查看" :visible.sync="checkVisible" width="30%" @closed="checkVisible=false">
            <el-form :model="calendarForm" :rules="rules" ref="calendarForm" label-width="85px">
                <el-form-item label="日程内容">
                    <el-input :value="calendarForm.content"></el-input>
                </el-form-item>
                <el-form-item label="日程类型">
                    <el-input :value="typeData[Number(calendarForm.type)-1]"></el-input>
                </el-form-item>

                <el-form-item v-if="calendarForm.type==2" label="参与班级">
                    <el-checkbox-group :value="calendarForm.class_id">
                        <el-checkbox v-for="(item,index) in class_options" :label="item.id" :key="index">{{item.rename}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-form-item v-if="calendarForm.type==3" label="参与年级">
                    <el-cascader v-model="calendarForm.grade_id" :options="orgData" disabled :props="orgDataProps" placeholder="请选择年级" :show-all-levels="false"></el-cascader>
                </el-form-item>

                <el-form-item v-if="calendarForm.type!=1&&calendarForm.type!=''" label="参与人员">
                    <template>
                        <el-checkbox-group :value="calendarForm.role_id">
                            <el-checkbox label="6">教师</el-checkbox>
                            <el-checkbox label="4">学生</el-checkbox>
                            <el-checkbox label="5">家长</el-checkbox>
                        </el-checkbox-group>
                    </template>
                </el-form-item>

                <el-form-item label="开始时间">
                    <el-date-picker v-model="calendarForm.start_time" disabled value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="结束时间">
                    <el-date-picker v-model="calendarForm.end_time" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="重要活动">
                    <el-radio-group :value="calendarForm.is_import">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="0">否</el-radio>
                    </el-radio-group>
                    <span class="is_import_tips">(重要活动有星号标记)</span>
                </el-form-item>

                <el-form-item label="重复">
                    <el-select v-model="calendarForm.repeat" placeholder="请选择周期" disabled>
                        <el-option v-for="item in repeat_options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="备注" class="textarea-item">
                    <el-input type="textarea" :rows="4" resize="none" disabled :value="calendarForm.remark"></el-input>
                </el-form-item>

                <el-form-item label="创建人：">
                    <span>{{c_creater_name}}</span>
                </el-form-item>

                <el-form-item label="创建日期：">
                    <span>{{c_create_time}}</span>
                </el-form-item>

            </el-form>
        </el-dialog>
    </div>
</template>
   
<script>
import moment from "moment";
import { fail } from 'assert';
export default {
    data() {
        return {
            // 年
            yearOptions: [],
            yearValue: "",
            // 月
            monthOptions: [],
            monthValue: "",
            //学期
            termData: [],
            teamOptions: [],

            weekFirstDay: "", //学期开始时间所在的周的第一天
            // 周
            weekOptions: [],
            weekValue: null,
            //后台学期数据
            // ---------------
            statusType: 0,//0新建，1编辑，2查看
            dialogVisible: false,
            //用户的身份:1、2:超级管理员；3前台管理员；4学生；5家长，6教师
            user_role: this.$store.getters.userInfo.role,
            user_id: this.$store.getters.userInfo.id,
            calendar_options: [
                {
                    value: "1",
                    label: "个人日程",
                    role: [1, 2, 3, 4, 5, 6]
                },
                {
                    value: "2",
                    label: "班级日程",
                    role: [1, 2, 3, 6]
                },
                {
                    value: "3",
                    label: "年级日程",
                    role: [1, 2, 3, 6]
                },
                {
                    value: "4",
                    label: "校级日程",
                    role: [1, 2, 3]
                }
            ],
            typeData: ["个人日程", "班级日程", "年级日程", "校级日程"],
            class_options: [],
            repeat_options: [
                {
                    value: "0",
                    label: "不重复"
                },
                {
                    value: "1",
                    label: "每天"
                },
                {
                    value: "2",
                    label: "每周"
                },
                {
                    value: "3",
                    label: "每月"
                }
            ],
            defaultCalendarForm: {
                id: null,
                content: "",
                type: "",
                start_time: "",
                end_time: "",
                is_import: "0",
                repeat: "0",

                remark: "",
                create_id: this.$store.getters.userInfo.id,
                class_id: [],
                grade_id: [],
                role_id: [], //参与人员id
                term_id: [] //学期id
            },
            calendarForm: {
                id: null,
                content: "",
                type: "",
                start_time: "",
                end_time: "",
                is_import: "0",
                repeat: "0",

                remark: "",
                create_id: this.$store.getters.userInfo.id,
                class_id: [],
                grade_id: [],
                role_id: [], //参与人员id
                term_id: [] //学期id
            },
            c_create_id: null,
            c_creater_name: null,
            c_create_time: null,
            rules: {
                content: [
                    {
                        required: true,
                        message: "请输入日程名称",
                        trigger: "blur"
                    }
                ],
                type: [
                    {
                        required: true,
                        message: "请选日程类型",
                        trigger: "change"
                    }
                ],
                start_time: [
                    {
                        // type: "date",
                        required: true,
                        message: "请选择开始时间",
                        trigger: "change"
                    }
                ],
                end_time: [
                    {
                        // type: "date",
                        required: true,
                        message: "请选择结束时间",
                        trigger: "change"
                    }
                ],
                class_id: [
                    {
                        type: "array",
                        required: true,
                        message: "请选择班",
                        trigger: "change"
                    }
                ],
                grade_id: [
                    {
                        type: "array",
                        required: true,
                        message: "请选择年级",
                        trigger: "change"
                    }
                ],
                role_id: [
                    {
                        type: "array",
                        required: true,
                        message: "请至少选择一个参与人",
                        trigger: "change"
                    }
                ],
                repeat: [
                    { required: true, message: "请选周期", trigger: "change" }
                ]
            },
            // 年级（组织架构多级下拉框）：
            orgParam: {
                data_type: "manage_tree",
                status: [1, 2],
                level: "<4"//多级数组只取到第三层
            },
            orgData: [],
            orgDataProps: {
                value: "id",
                label: "name",
                children: "children"
            },
            // 日程列表：
            month_view: true, //是否是月视图
            select_time: "", //月视图的月份
            term_id: null,
            //vue-full-calendar插件配置：
            config: {
                locale: "zh-cn", //语言
                //自定义了月视图的显示格式
                views: {
                    month: {
                        titleFormat: "YYYY" + "年" + "MM" + "月"
                    },
                },
                //禁止拖动日程块
                editable: false,
                //按钮文本
                buttonText: {
                    today: "回到今天",
                    month: "月",
                    week: "周",
                    day: "日"
                },
                // -----axisFormat在fullcalendar-3.3.1中已经移除，周视图左侧垂直轴的时间显示格式化，如下设置：
                allDaySlot: false,//allday 整天的日程是否显示
                slotLabelFormat: 'HH:mm',//确定将在议程视图的垂直轴上显示的时间文本。
                slotDuration: '01:00:00',//在agenda的视图中, 两个时间之间的间隔(分钟)
                scrollTime: '00:00:00',//当切换到agenda时，初始滚动条滚动到的时间位置，默认在6点钟的位置
                minTime: '00:00:00',//设置显示的时间从几点开始
                maxTime: '24:00:00',//设置显示的时间从几点结束
                slotEventOverlap: false,//周视图中的事件显示是否可以重叠覆盖
                // -----
                //默认显示月视图
                defaultView: "month",
                //默认时间
                defaultDate: "",
                // 设置日历时间范围
                validRange: {
                    start: "",
                    end: ""
                }
            },
            eventTypeData: ["#bcecff", "#c3f6cf", "#dde2ff", "#ffe0fb"],
            // 日程事件：
            events: [],
            submitLoading: false,//提交日程信息时加载中提示
            checkVisible: false,//查看日程弹窗
        };
    },
    created() {
        this.config.defaultDate = timestampToTime();//（初始会插件的时间）：获取当前日期时分秒默认时间，直接赋值给插件
        this.getOrgData();//年级
        this.getUserClass();//班级
        this.getTeam();//学期
        this.filterCalendarOptions();//日程类型
    },
    watch: {
        "config.defaultDate"(a, b) {
            if (a != b) {
                // 跳到指定的日期
                this.$refs.calendar.fireMethod(
                    "gotoDate",
                    this.config.defaultDate
                );
            }
        }
    },
    methods: {
        // 获取年级
        getOrgData() {
            // 重写成功回调
            let success = data => {
                // 后台返回的多层嵌套数据，第3层的children键值对值为[]时，element的cascader级联选择器在页面显示4级为空白，所以要把第3层的children键值对的值设为undefined
                this.orgData = this.getTreeData(data.data);
            };
            this.$ajax.get("api/org/org", {
                params: this.orgParam,
                func: { success: success }
            });
        },
        // 递归遍历将多层嵌套数组里最里的空children数组的值改为undefined
        getTreeData(data) {
            // 循环遍历json数据
            for (var i = 0; i < data.length; i++) {
                if (data[i].children.length < 1) {
                    // children若为空数组，则将children设为undefined
                    data[i].children = undefined;
                } else {
                    // children若不为空数组，则继续 递归调用 本方法
                    this.getTreeData(data[i].children);
                }
            }
            return data;
        },
        //获取用户的班级：
        getUserClass() {
            let success = res => {
                this.class_options = res.data;
            };
            this.$ajax({
                url: "api/org/class_userid",
                method: "get",
                params: {
                    user_id: this.$store.getters.userInfo.id
                },
                func: { success: success }
            });
        },
        //获取用户的学期数据：
        getTeam() {
            let success = res => {
                // console.log(res.data);
                //如果用户没学期数据，隐藏周视图切换按钮
                if (res.data.length == 0) {
                    document.getElementsByClassName("fc-agendaWeek-button")[0].style.display = "none";
                    return false;
                }
                this.teamOptions = res.data;
            };
            this.$ajax({
                url: "api/term/term_list",
                method: "get",
                params: {},
                func: { success: success }
            });
        },
        //点击切换月、周按钮的时候，获取当前视图信息:
        getView(view) {
            // console.log(view);
            if (view.name == "month") {
                this.month_view = true;
                this.select_time = view.title
                    .replace("年", "-")
                    .replace("月", "");
                this.getYearMonth(this.select_time);
                this.getScheduleList();//根据时间获取数据
            } else if (view.name == "agendaWeek") {
                this.month_view = false;
                //view.title当前周视图标题上显示的日期
                //切割，取空格前面部分，去年月字，-隔开，得周一日期的年、月、日数字
                // 当前周一：
                // let tDay = view.title
                //   .split(" ")[0]
                //   .replace("年", "-")
                //   .replace("月", "-")
                //   .split("-");
                // // 学期第一天：
                // let fDay = this.config.validRange.start.split(" ")[0].split("-");
                // // 判断周一是当前年份中的第几周
                // this.weekValue = getWeekNumber(tDay[0], tDay[1], tDay[2]) - getWeekNumber(fDay[0], fDay[1], fDay[2]) + 1;
                // console.log(_title);
                // console.log(this.config.validRange);
                // console.log(tDay);
                // console.log(fDay);
                // console.log(this.weekValue);
            }
        },
        // 年/月select框，自主设置日历顶部中间位置的日期
        changeCurrentTime() {
            this.config.defaultDate =
                this.yearValue + "-" + this.add_o(this.monthValue);
            // console.log(this.config.defaultDate)
        },
        add_o(s) {
            return s < 10 ? "0" + s : s;
        },

        //select框选学期
        getTerm() {
            for (let i = 0; i < this.teamOptions.length; i++) {
                if (this.term_id == this.teamOptions[i].id) {
                    this.weekOptions = this.teamOptions[i].weeks;//选中的学期包含多少周，此处是一个数字
                    this.weekFirstDay = this.getWeekStartEnd(this.teamOptions[i].start_time);//根据学期的初始事时间，判断这个学期第一周的日期是哪天
                }
            }
            // console.log(this.weekFirstDay);
        },
        // select框选周
        getTermWeek() {
            // console.log(this.weekValue)
            this.getScheduleList();//根据学期和周获取数据
            this.config.defaultDate = this.plus_or_minus(
                this.weekFirstDay.start,
                (this.weekValue - 1) * 7
            );
        },
        //根据某个日期，获取所在周的开始和结束时间
        getWeekStartEnd(date) {
            let oneDayTime = 24 * 60 * 60 * 1000;
            let now = new Date(date);
            let nowTime = now.getTime();
            let day = now.getDay();
            if (day == 0) {
                let end = moment(new Date(date)).format("YYYY-MM-DD");
                let start = moment(new Date(date) - 6 * oneDayTime).format(
                    "YYYY-MM-DD"
                );
                return { start, end };
            } else {
                let oneDayTime = 24 * 60 * 60 * 1000;
                let MondayTime = nowTime - (day - 1) * oneDayTime;
                let SundayTime = nowTime + (7 - day) * oneDayTime;
                let start = moment(new Date(MondayTime)).format("YYYY-MM-DD");
                let end = moment(new Date(SundayTime)).format("YYYY-MM-DD");
                return { start, end };
            }
        },
        //日期data,返回day天后的日期
        plus_or_minus(date, day) {
            let oneDayTime = 24 * 60 * 60 * 1000;
            let now = new Date(date);
            let nowTime = now.getTime();
            let Times = nowTime + day * oneDayTime;
            return moment(new Date(Times)).format("YYYY-MM-DD");
        },
        //月视图的时候转换数据格式
        getYearMonth(_date) {
            this.yearValue = "";
            this.yearOptions = [];
            this.monthValue = "";
            this.monthOptions = [];
            // （月视图）获取当前年份\月份
            // console.log(_date);
            //从当前的日期中截取出年和月的数字
            var reg = /^(\d{4})-(\d{1,2})/;
            _date.match(reg);
            let _year = parseInt(RegExp.$1);
            let _month = parseInt(RegExp.$2);
            this.yearValue = _year;
            this.monthValue = _month;
            for (let i = 0; i < 3; i++) {
                let _option = {};
                _option["yearValue"] = _year + (i - 1);
                _option["label"] = _year + (i - 1) + "年";
                this.yearOptions.push(_option);
            }
            // console.log(this.yearOptions)
            for (let j = 0; j < 12; j++) {
                let m_option = {};
                m_option["monthValue"] = j + 1;
                m_option["label"] = j + 1 + "月";
                this.monthOptions.push(m_option);
            }
            // console.log(this.monthOptions)
        },
        //获取用户的日程列表：
        getScheduleList() {
            // console.log(this.month_view);
            let success = res => {
                let res_data = res.data;
                this.changeCalendarData(res_data);
            };
            let _params;
            if (this.month_view == true) {//月视图时
                _params = {
                    create_id: this.$store.getters.userInfo.id,
                    time_type: "1",
                    select_time: this.select_time
                };
            } else {//周视图时
                _params = {
                    create_id: this.$store.getters.userInfo.id,
                    time_type: "2",
                    term_id: this.term_id,
                    weeks: this.weekValue
                };
            }
            this.$ajax({
                url: "api/schedule/schedule_list",
                method: "get",
                params: _params,
                func: { success: success }
            });
        },
        //转成符合日历插件的数据格式：
        changeCalendarData(_data) {
            let event_data = [];
            for (var key in _data) {
                if (_data[key].length != 0) {
                    _data[key].forEach((val, inx, arr) => {
                        event_data.push(val);
                    });
                }
            }
            if (event_data.length != 0) {
                let _event_data = this.jsonUniq(event_data, "id");
                let _obj1 = _event_data.map((item, val, arr) => {
                    item["className"] =
                        item.is_import == 1 ? "el-icon-star-on" : ""; //重要的事件添加星号样式
                    item.type = this.eventTypeData[item.type - 1]; //不同事件赋予不同颜色背景颜色
                    //修改成符合插件事件json格式的键名：
                    return {
                        id: item.id,
                        create_id: item.create_id,
                        create_name: item.create_name,
                        create_time: item.create_time,
                        title: item.content,
                        start: item.start_time,
                        // end: this.filterEndDate(item.end_time),
                        endDate: this.filterEndDate(item.end_time),
                        end: item.end_time,
                        color: item.type,
                        className: item.className,
                        is_import: item.is_import,
                        repeat: item.repeat,
                        remark: item.remark,
                        role_id: item.role_id,
                        grade_id: item.grade_id,
                        class_id: item.class_id,

                    };
                });
                this.events = _obj1;
            } else {
                this.events = [];
            }
        },
        // 结束日期时间是0点以后的，那日期值+1
        filterEndDate(endDate) {
            // console.log(endDate)
            let date = endDate.split(" ")[0].split("-");//字符串日期部分
            let hms = endDate.split(" ")[1];//字符串时分秒部分
            if (hms === "00:00:00") {
                return endDate;
            } else {
                //超出了0时的，日期范围到第二天了，日期+1，重写字符串
                return date[0] + "-" + date[1] + "-" + (Number(date[2]) + 1) + " " + "00:00:00";
            }
        },
        //json数组去重：
        jsonUniq(arr, key) {
            let arr1 = [arr[0]];
            arr.forEach(function (item1, idx1) {
                let flag = false;
                arr1.forEach(function (item2, idx2) {
                    if (item1[key] == item2[key]) {
                        flag = true;
                        return;
                    }
                });
                if (!flag) {
                    arr1.push(item1);
                }
            });
            return arr1;
        },
        //选择日程类型
        filterCalendarOptions() {
            var temp_data = [];
            for (let i = 0; i < this.calendar_options.length; i++) {
                if (arrayIntersection(this.calendar_options[i].role, this.user_role).length > 0
                ) {
                    temp_data.push(this.calendar_options[i]);
                }
            }
            this.calendar_options = deep_clone(temp_data);
        },
        //新建日程按钮：
        addNewCalendar() {
            this.calendarForm = deep_clone(this.defaultCalendarForm);//清空数据
            // this.$refs['calendarForm'].clearValidate();//清除所有的必选验证
            this.statusType = 0;//切换成新建状态
            this.dialogVisible = true;//显示弹窗

        },
        //弹窗关闭事件：（新建和编辑共用一个含form表单的弹窗，这里做清空处理）
        closeDialog() {
            this.calendarForm = deep_clone(this.defaultCalendarForm);//清空数据
            this.$refs['calendarForm'].clearValidate();//清除所有的必选验证
        },
        //根据不同日程，给日程事件不同背景颜色
        changeColor(_color) {
            switch (_color) {
                case "#bcecff":
                    return "1";
                    break;
                case "#c3f6cf":
                    return "2";
                    break;
                case "#dde2ff":
                    return "3";
                    break;
                case "#ffe0fb":
                    return "4";
                    break;
            }
        },
        //确定按钮：
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (this.statusType == 0) {
                        this.changeCalendar("post");
                    } else if (this.statusType == 1) {
                        this.changeCalendar("put");
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        changeCalendar(_method) {
            this.submitLoading = true;
            let success = res => {
                this.submitLoading = false;
                if (_method == "post") {
                    this.$message.success("新增成功");
                } else if (_method == "put") {
                    this.$message.success("编辑成功");
                }
                this.$refs.calendar.fireMethod('changeView', "month");//切换回默认月视图
                this.getScheduleList();
                this.dialogVisible = false;
            };
            let fail = res => {
                this.$message.error(res.msg);
                this.submitLoading = false;
            };
            this.$ajax({
                url: "api/schedule/schedule",
                method: _method,
                data: this.calendarForm,
                func: { success: success, fail: fail }
            });
        },
        //点击日程，编辑：
        eventSelected(view) {
            // console.log(view)
            if (view.create_id == this.user_id) {
                this.dialogVisible = true;
                this.statusType = 1;
            } else {
                this.checkVisible = true;
                this.statusType = 2;
            }
            this.calendarForm.content = view.title;
            this.calendarForm.type = this.changeColor(view.color);
            this.calendarForm.start_time = view.start._i;
            this.calendarForm.end_time = view.end._i;
            this.calendarForm.id = view.id;
            this.calendarForm.class_id = view.class_id;
            //把字符串转换成数字类型（弹窗中elementui中多级联动得到的数组每一项的值都是数字类型），不然显示不了
            for (let i = 0; i < view.grade_id.length; i++) {
                this.calendarForm.grade_id.push(Number(view.grade_id[i]));
            }
            this.calendarForm.repeat = view.repeat+'';
            this.calendarForm.remark = view.remark;
            this.calendarForm.role_id = view.role_id;
            this.calendarForm.is_import = view.is_import.toString();
            this.c_create_id = view.create_id;
            this.c_creater_name = view.create_name;
            this.c_create_time = view.create_time;
            // this.changeCalendar("post");
        },
        // 删除按钮：
        delCalendar() {
            let yes = data => {
                let success = res => {
                    this.$message.success("删除成功");
                    this.dialogVisible = false;
                    this.$refs.calendar.fireMethod('changeView', "month");//删除成功就切换回月视图
                    this.getScheduleList();
                };
                this.$ajax({
                    url: "api/schedule/schedule",
                    method: "delete",
                    params: {
                        id: this.calendarForm.id
                    },
                    func: { success: success }
                });
            };
            let cancel = data => { };
            this.e_confirm({
                yes: yes,
                cancel: cancel,
                txt: "确定删除此个日程吗？"
            });
        }
    }
};
</script>
<style lang="scss">
@import "~fullcalendar/dist/fullcalendar.css";

.select-date {
    display: inline-block;
    .el-select {
        input::-webkit-input-placeholder {
            color: #000;
            font-size: 18px;
            text-align: center;
        }
        .el-input__inner {
            height: 30px;
            line-height: 30px;
            border: none;
            font-size: 18px;
            font-weight: 600;
            color: #000;
        }
    }
    .select-year {
        .el-input {
            width: 105px;
        }
    }
    .select-month {
        .el-input {
            width: 80px;
        }
    }
    .select-team {
        .el-input {
            width: 220px;
        }
    }
    .select-week {
        .el-input {
            width: 100px;
        }
    }
}
</style>
